
































































































import { defineComponent, ref } from '@vue/composition-api';
import SearchPane from '@/components/SettouMessageBoard/components/SearchPane/index.vue';
import BoardEntryRow from '@/components/SettouMessageBoard/components/BoardEntryRow.vue';
import BoardEntryEditModal from '@/components/SettouMessageBoard/components/BoardEntryEditModal/index.vue';
import PhotoModal from '@/components/lib/PhotoModal/index.vue';
import { useBoardCore } from '@/components/SettouMessageBoard/composables/useBoardCore';
import useBoardDisplayControl from '@/components/SettouMessageBoard/composables/useBoardDisplayControl';
import { useBoardEntryCrud } from '@/components/SettouMessageBoard/composables/useBoardEntryCrud';
import { useBoardEntryPermissions } from '@/components/SettouMessageBoard/composables/useBoardEntryPermissions';
import { usePhotoModal } from '@/components/SettouMessageBoard/composables/usePhotoModal';

export default defineComponent({
  components: {
    SearchPane,
    BoardEntryRow,
    PhotoModal,
    BoardEntryEditModal,
  },
  setup() {
    // SP版テンプレートで使う値のみ公開する(タブページャー・CSV出力はPC版専用のため公開しない)
    const {
      state,
      isSuperAdmin,
      paginatedBoardEntries,
      onChangeBoardTab,
      dtFormat,
      searchBoardEntries,
    } = useBoardCore();
    const {
      currentBoardTab,
      isHonbuBoard,
      isMaintenanceBoard,
      canUseHonbuReportSearchConditions,
      boardTabDepartmentDisp,
      isCreatableRole,
      isRepliableRole,
    } = useBoardDisplayControl();
    const {
      shouldShowEditModal,
      shouldShowDeleteModal,
      createBoardEntry,
      editBoardEntry,
      addBoardEntry,
      updateBoardEntry,
      cancelEditBoardEntry,
      tryDeleteBoardEntry,
      deleteBoardEntry,
    } = useBoardEntryCrud();
    const { isEditable, isDeletable, canCreateBoardEntry } = useBoardEntryPermissions();
    const { photoModalState, showPhotoModal, hidePhotoModal } = usePhotoModal();
    const showSearchPane = ref<boolean>(false);

    return {
      state,
      isSuperAdmin,
      paginatedBoardEntries,
      onChangeBoardTab,
      dtFormat,
      searchBoardEntries,
      currentBoardTab,
      isHonbuBoard,
      isMaintenanceBoard,
      canUseHonbuReportSearchConditions,
      boardTabDepartmentDisp,
      isCreatableRole,
      isRepliableRole,
      shouldShowEditModal,
      shouldShowDeleteModal,
      createBoardEntry,
      editBoardEntry,
      addBoardEntry,
      updateBoardEntry,
      cancelEditBoardEntry,
      tryDeleteBoardEntry,
      deleteBoardEntry,
      isEditable,
      isDeletable,
      canCreateBoardEntry,
      photoModalState,
      showPhotoModal,
      hidePhotoModal,
      showSearchPane,
    };
  },
});
